export default function sortOptions(options) {
	return options.sort((a, b) => a.text.localeCompare(b.text));
}
